import PlusCircleIcon from '@atlaskit/icon-lab/core/plus-circle';
import * as React from 'react';

export function SvgPlusCircle() {
  return <PlusCircleIcon label="" testId="ads-refreshed-icon" />;
}
